<template>
  <div class="menu-div"
       v-if="isShowMenu">
    <div @click="goToIndex">
      <i class="iconfont">&#xe638;</i>
      <span>{{$t("首页")}}</span>
    </div>
    <div @click="goToRecharge">
      <i class="iconfont">&#xe639;</i>
      <span>{{$t("充值")}}</span>
    </div>
    <div @click="goToMy">
      <i class="iconfont">&#xe63a;</i>
      <span>{{$t("个人")}}</span>
    </div>
    <div @click="goToCustomer">
      <i class="iconfont">&#xe63b;</i>
      <span>{{$t("客服")}}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'menu-m',
  data() {
    return {};
  },
  methods: {
    goToIndex() {
      this.menuIcon = '&#xe650;';
      this.isShowMenu = false;
      location.href = './index_m.html';
    },
    goToRecharge() {
      this.menuIcon = '&#xe650;';
      this.isShowMenu = false;
      location.href = './recharge_m.html';
    },
    goToMy() {
      this.menuIcon = '&#xe650;';
      this.isShowMenu = false;
      location.href = './account_m.html';
    },
    goToCustomer() {
      this.menuIcon = '&#xe650;';
      this.isShowMenu = false;
      location.href = './help_m.html';
    }
  },
  props: ['isShowMenu']
};
</script>
<style lang="less">
.menu-div {
  position: fixed;
  top: 0;
  width: 100%;
  height: 100vh;
  background: #fff;
  opacity: 0.9;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 9;
  margin-top: 0.98rem;
  div {
    display: flex;
    flex-direction: column;
    margin-top: 1.2rem;
    font-size: 0.28rem;
    align-items: center;
    width: 100%;
    text-align: center;
  }
  i {
    font-size: 0.6rem;
    margin-bottom: 0.08rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/common/components/meau_m.vue